export default {
  Na: "invalid_api_key",
  Xa: "blacklisted",
  $a: "no_device_identifier",
  Ba: "invalid_json_response",
  Ra: "empty_response",
  __: "sdk_auth_error",
};
